var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\n  #define IN in\n  #define texture2D(a,b) texture( a, b )\n#else\n  #define IN varying\n  #define FragColor gl_FragColor\n#endif\n\n#if __VERSION__ == 300\n  out vec4 FragColor;\n#endif';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
